import * as yup from 'yup';

const patternTwoDigisAfterComma = /^\d+(\.\d{0,2})?$/;

export const dollarValueValidationSchema = yup
  .number()
  .positive()
  .typeError('This field is required')
  .test('is-decimal', 'The amount should be a decimal with maximum two digits after comma', val => {
    if (val !== undefined) {
      return patternTwoDigisAfterComma.test(val.toString());
    }
    return true;
  });
